module.exports = function() {
  return new Worker(__webpack_public_path__ + "6e8836e2824ccc529026.worker.js");
};